import React from 'react';
import { Star } from 'lucide-react';
const reviews = [{
  text: 'Ich war skeptisch, aber nach 2 Wochen hatte Balu zum ersten Mal wieder normalen Stuhlgang. Wir sind so erleichtert.',
  author: 'Sandra (Hund: Balu, Labrador, 4 Jahre)',
  image: 'https://images.unsplash.com/photo-1591769225440-811ad7d6eab3?q=80&w=150&auto=format&fit=crop'
}, {
  text: 'Tom hatte wochenlang tagelang keinen Stuhlgang und einen aufgeblähten Bauch. Nach dem Topping hat sich das innerhalb von 10 Tagen komplett gelegt.',
  author: 'Thomas (Hund: Tom, Golden Retriever, 6 Jahre)',
  image: 'https://images.unsplash.com/photo-1633722715463-d30f4f325e24?q=80&w=150&auto=format&fit=crop'
}, {
  text: 'Nalas Verdauung war extrem träge. Seit wir das Topping geben, ist ihr Bauch weich und sie hat keine Schmerzen mehr. Absolut empfehlenswert!',
  author: 'Lisa (Hund: Nala, Mischling, 3 Jahre)',
  image: 'https://images.unsplash.com/photo-1587300003388-59208cc962cb?q=80&w=150&auto=format&fit=crop'
}];
export function Testimonials() {
  return <section className="px-4 mb-12" data-id="element-131">
      <h3 className="font-handwriting text-3xl font-bold text-center text-forest mb-8" data-id="element-132">
        Was andere Hundebesitzer sagen
      </h3>

      <div className="space-y-4" data-id="element-133">
        {reviews.map((review, index) => <div key={index} className="bg-card p-6 rounded-xl shadow-sm border border-brown/5" data-id="element-134">
            <div className="flex items-center gap-3 mb-4" data-id="element-135">
              <img src={review.image} alt={review.author} className="w-10 h-10 rounded-full object-cover border border-brown/10 shrink-0" data-id="element-136" />
              <div data-id="element-137">
                <div className="flex gap-1 mb-1" data-id="element-138">
                  {[...Array(5)].map((_, i) => <Star key={i} size={14} className="fill-brown text-brown" data-id="element-139" />)}
                </div>
                <p className="font-serif text-xs font-bold text-forest" data-id="element-140">
                  {review.author}
                </p>
              </div>
            </div>
            <p className="font-serif text-text/90 italic text-sm" data-id="element-141">
              "{review.text}"
            </p>
          </div>)}
      </div>
    </section>;
}